import i18next from "src/i18n/config";

import { ApkFileStatus } from "@files/utils/apkStatus";
import { activityIconClass } from "@shared/Loading";

export const getPrimaryButtonProps = (
    status: ApkFileStatus,
    unsuccesfulAnalyzerExist: boolean,
    mayInstallApp: boolean,
    version?: string,
) => {
    switch (status) {
        case "processing":
            return {
                tooltip: i18next.t("sidepanels:devicePanel.tooltip.processing"),
                iconClass: activityIconClass,
                disabled: true,
            };
        case "analyzerFailed":
            return {
                tooltip: i18next.t("sidepanels:devicePanel.tooltip.analysisFailed"),
                iconClass: "fa-solid fa-triangle-exclamation",
                disabled: true,
            };
        case "toUpdate":
            return {
                tooltip: mayInstallApp
                    ? version
                        ? i18next.t("sidepanels:devicePanel.tooltip.updateApplication", { version })
                        : i18next.t("sidepanels:devicePanel.tooltip.updateApplicationFallback")
                    : i18next.t("sidepanels:devicePanel.tooltip.noPermissionToUpdatePackages"),
                disabled: unsuccesfulAnalyzerExist || !mayInstallApp,
                iconClass: "fa-solid fa-angles-up",
            };
        case "toInstall":
            return {
                tooltip: mayInstallApp
                    ? i18next.t("sidepanels:devicePanel.tooltip.installApplication")
                    : i18next.t("sidepanels:devicePanel.tooltip.noPermissionToInstallPackages"),
                disabled: unsuccesfulAnalyzerExist || !mayInstallApp,
                iconClass: "fa-solid fa-arrow-right-to-bracket",
            };
        case "invalidApk":
            return {
                tooltip: i18next.t("sidepanels:devicePanel.tooltip.invalidApplication"),
                disabled: true,
                iconClass: "fa-solid fa-arrow-right-to-bracket",
            };
        case "currentVersion":
            return {
                tooltip: i18next.t("sidepanels:devicePanel.tooltip.currentVersion"),
                disabled: true,
                iconClass: "fa-solid fa-check",
            };
        default:
            return {
                tooltip: i18next.t("sidepanels:devicePanel.tooltip.outdatedVersion"),
                disabled: true,
                iconClass: "fa-solid fa-angles-down",
            };
    }
};
